/**
 * Desembrulha cada `<a>` para o seu próprio texto: o conteúdo sobrevive, o `href` morre.
 *
 * @param {Element} corpo `document.body` do documento inerte.
 */
function desembrulharAncoras(corpo) {
  for (const ancora of corpo.querySelectorAll('a')) {
    const pai = ancora.parentNode
    if (!pai) continue
    while (ancora.firstChild) {
      pai.insertBefore(ancora.firstChild, ancora)
    }
    ancora.remove()
  }
}

/**
 * Remove cada `<img>` — o navegador buscaria uma URL escolhida pelo modelo.
 *
 * @param {Element} corpo `document.body` do documento inerte.
 */
function removerImagens(corpo) {
  for (const imagem of corpo.querySelectorAll('img')) {
    const pai = imagem.parentNode
    if (pai) imagem.remove()
  }
}

/**
 * Remove do HTML renderizado pelo markdown-it qualquer poder de navegação:
 * desembrulha `<a>` para texto e remove `<img>`. Função pura, sem efeito colateral.
 *
 * Usada como `postrender` do `vue-markdown` (prop documentada, default identidade),
 * junto de `html=false` e `linkify=false`. Os três formam a AC-4.2:
 *   1. `<a href>` cru        -> `html=false` faz o markdown-it escapar a tag
 *   2. `[texto](url)`        -> `html=false` NÃO afeta; aqui o `<a>` é desembrulhado
 *   3. `![alt](url)`         -> `html=false` NÃO afeta e o navegador BUSCA a URL
 *                               (pixel de rastreio / exfiltração pelo path); `<img>` removido
 *   4. URL nua               -> `linkify=false` a montante
 *
 * `DOMParser.parseFromString` produz um documento **inerte**: não executa script nem
 * dispara carga de imagem, diferente de `innerHTML` em nó destacado. Não é a dívida do
 * `sanitize-ia-html.js` — lá o regex precisa entender HTML arbitrário do modelo; aqui o
 * conjunto de tags é fechado (só o que o markdown-it emite) e quem tokeniza é o parser
 * do navegador.
 *
 * @param {String} html HTML já renderizado pelo markdown-it com `html=false`.
 * @returns {String} HTML sem `<a>` e sem `<img>`.
 */
export function neutralizarAncoras(html) {
  if (!html) return ''

  const doc = new DOMParser().parseFromString(html, 'text/html')
  const corpo = doc.body
  if (!corpo) return ''

  desembrulharAncoras(corpo)
  removerImagens(corpo)

  return corpo.innerHTML
}
